<template>
  <div>
    <p>{{ $t("verification.text") }}</p>
    <verification-code
      v-on:verifed="onVerifed"
      :email="email"
      class="mb-5"
    ></verification-code>
  </div>
</template>

<script>
// @ is an alias to /src
import VerificationCode from '@/components/VerificationCode'

export default {
  name: "EmailVerification",
  components: {
    VerificationCode,
  },
  props: {
    email: {
      type: Object,
      default: null
    }
  },
  methods: {
    onVerifed(state) {
      if (state) {
        // перейдем на страницу с поздравлением
        this.$router.push({ name: 'verificationSuccess', props: { email: this.email } });
      }
    },
  },
};
</script>

<style scoped>
</style>